export interface ExperimentConfig {
  id: string;
  title: string;
  tagline: string;
}

export abstract class ExperimentBase {
  protected config: ExperimentConfig;
  protected headerElement: HTMLElement | null = null;
  protected contentElement: HTMLElement | null = null;
  protected taglineElement: HTMLElement | null = null;

  constructor(config: ExperimentConfig) {
    this.config = config;
  }

  initialize(): void {
    // Find the experiment's section elements
    const section = document.getElementById(`${this.config.id}-section`);
    if (!section) return;

    this.headerElement = section.querySelector('.experiment-header');
    this.contentElement = section.querySelector('.experiment-content');
    this.taglineElement = section.querySelector('.tagline');

    this.updateHeader();
    this.setupContent();
  }

  protected updateHeader(): void {
    if (this.taglineElement) {
      this.taglineElement.innerHTML = this.config.tagline;
    }
  }

  protected abstract setupContent(): void;

  public abstract activate(): void;

  public deactivate(): void {
    // Override in subclasses if cleanup is needed
  }
}